import { API_HOST_URL } from '@/app/Dataman-Backend';

export const FILES_PATHS = {
  files: `${API_HOST_URL}/api/files`,
};

/**
 * @param {string} path
 * @returns {string}
 */
export const toFileDownloadUrl = (path) => (path.startsWith('http') ? path : `${API_HOST_URL}${path}`);
